<template>
  <base-wrapper class="space-y-4">
    <base-card :title="`${editing ? 'Edit' : 'Tambah'} Topup Saldo Deposit SC`">
      <form class="grid gap-4 sm:grid-cols-6" @submit.prevent="onSubmit">
        <div class="sm:col-span-6">
          <base-input inset with-label label="Tanggal" disabled :value="date" />
        </div>
        <div class="sm:col-span-3">
          <search-office-input :disabled="editing" v-model="office" />
        </div>
        <div class="sm:col-span-3">
          <base-input
            id="nama_stockist_center"
            inset
            with-label
            label="Nama Stockist Center"
            placeholder="SC1"
            disabled
            :value="office.name"
          />
        </div>
        <div class="sm:col-span-2">
          <base-input
            id="nominal"
            inset
            with-label
            label="Nominal Topup"
            placeholder="100.000"
            type="text"
            currency
            v-model="amount"
          />
        </div>
        <div class="sm:col-span-2">
          <base-input
            id="nilai_pengali"
            inset
            with-label
            label="Nilai Pengali"
            placeholder="2"
            type="text"
            currency
            v-model="multipier"
          />
        </div>
        <div class="sm:col-span-2">
          <base-input
            inset
            with-label
            label="Nilai Barang"
            placeholder="100.000"
            type="text"
            disabled
            :value="(amountAsNumber * multipier) | toCurrency"
          />
        </div>
        <div class="col-span-full">
          <base-input
            id="keterangan"
            inset
            with-label
            label="Keterangan"
            placeholder="Topup deposit"
            type="text"
            v-model="description"
          />
        </div>
        <div class="flex items-center gap-2 sm:col-span-2">
          <base-button :disabled="disabled">Simpan</base-button>
          <base-button
            type="button"
            color="white"
            :to="{ name: 'penjualan.topup.deposit-sc' }"
            >Kembali</base-button
          >
        </div>
      </form>

      <loading v-if="loading" />
    </base-card>
  </base-wrapper>
</template>

<script>
import dayjs from 'dayjs';
import SearchOfficeInput from '@/components/office/search-office-input.vue';
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';

export default {
  components: { SearchOfficeInput },
  mixins: [requestMixin],
  data() {
    return {
      amount: null,
      date: dayjs().format('YYYY-MM-DD'),
      office: {
        id: null,
        code: null,
        searchCode: null,
        originalCode: null,
        name: null,
      },
      loading: false,
      multipier: null,
      description: null
    };
  },
  computed: {
    editing() {
      return !!this.$route.params.id
    },
    disabled() {
      return !this.office.id || !this.amount;
    },
    amountAsNumber() {
      if (!this.amount) {
        return 0
      }

      return Number(this.amount.replace(/\D/gi, ''))
    }
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    getCreateRequest() {
      return this.request(
        `/api/v1/offices/${this.office.id}/-actions/top-up-sc`,
        {
          method: 'post',
          data: {
            trx_type: 'deposit_balance',
            amount: this.amountAsNumber,
            multipier: this.multipier,
            description: this.description
          },
        }
      )
    },
    getEditRequest() {
      return this.request(
        `/api/v1/balance-trxes/${this.$route.params.id}`,
        {
          method: 'patch',
          data: {
            data: {
              id: this.$route.params.id,
              type: 'balance-trxes',
              attributes: {
                deposit_amount: this.amountAsNumber,
                deposit_multiplier: this.multipier,
                description: this.description
              }
            },
          },
        }
      )
    },
    async loadEditForm() {
      this.loading = true

      const [res, err] = await this.request(`/api/v1/balance-trxes/${this.$route.params.id}`, {
        params: {
          'include': 'office',
          'fields[balance-trxes]': 'deposit_amount,deposit_multiplier,description,createdAt,office',
          'fields[offices]': 'code,name'
        }
      })

      if (!err) {
        this.amount = `${res.data.attributes.deposit_amount}`
        this.date = dayjs(res.data.attributes.createdAt).format('YYYY-MM-DD')
        this.multipier = res.data.attributes.deposit_multiplier
        this.description = res.data.attributes.description

        const office = this.getSingleIncluded(res, res.data.relationships.office.data.id)

        this.office.id = office.id
        this.office.code = office.attributes.code
        this.office.searchCode = office.attributes.code
        this.office.originalCode = office.attributes.code
        this.office.name = office.attributes.name
      }

      this.loading = false
    },
    async onSubmit() {
      this.loading = true;

      const [, err] = this.editing ? await this.getEditRequest() : await this.getCreateRequest();

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      } else {
        this.$router.push({ name: 'penjualan.topup.deposit-sc' });
      }

      this.loading = false;
    },
    async setDefaultMultipier () {
      this.loading = true

      const [res, err] = await this.request(`/api/v1/setups`, {
        params: {
          'filter[setup_key]': 'sc_deposit_multiplier',
          'fields[setups]': 'setup_value'
        }
      })

      if (!err && res.data.length) {
        this.multipier = res.data[0].attributes.setup_value
      }

      this.loading = false
    }
  },
  created() {
    if (!this.$route.params.id) {
      this.setDefaultMultipier()
    } else {
      this.loadEditForm()
    }
  }
};
</script>
